export const CONFERENCE_STATUSES = {
  WAITING: 'waiting',
  TALKING: 'talking',
  DONE: 'done',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
  DELETED: 'deleted',
};

export const TRANSCRIPT_STATUSES = {
  INITIAL: 'initial',
  UPLOADED: 'uploaded',
  COMPLETE: 'complete',
  ERROR_UPLOADING: 'error_uploading',
  ERROR_MERGING: 'error_merging',
  ERROR_VALIDATION: 'error_validation',
  ERROR_DELETE_FROM_TWILIO: 'error_twilio_delete',
  ERROR_UPLOAD_TO_CLOUDSEARCH: 'error_cloudsearch_upload',
  ERROR_EMAIL_SEND: 'error_email_send',
  DELETED: 'deleted',
  CANCELLED: 'cancelled',
};

export default {
  CONFERENCE_STATUSES,
  TRANSCRIPT_STATUSES,
};



// WEBPACK FOOTER //
// ./config/statuses-constants.js